const KEY = "hc_stripe_checkout_session_id";

export function stashStripeCheckoutSessionId(sessionId) {
  try {
    const id = String(sessionId ?? "").trim();
    if (!id) return;
    sessionStorage.setItem(KEY, JSON.stringify({ sessionId: id, storedAt: Date.now() }));
  } catch (_) {}
}

export function peekStripeCheckoutSessionId(maxAgeMs = 1000 * 60 * 60 * 24) {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const { sessionId, storedAt } = JSON.parse(raw);
    if (!sessionId || typeof storedAt !== "number") return null;
    if (Date.now() - storedAt > maxAgeMs) return null;
    return String(sessionId).trim();
  } catch {
    return null;
  }
}

export function clearStripeCheckoutSessionId() {
  try {
    sessionStorage.removeItem(KEY);
  } catch (_) {}
}
